// import pptxgen from 'pptxgenjs';
import { getImageUrl, removeAttributes } from '../../util'
import { logoMaven } from '../../assets/images'
import { HTMLToJSON } from 'html-to-json-parser' // ES6

export const pptWidth = 13.3
export const pptHeight = 7.5

export const pxToInch = (px = 0) => {
  return px * 0.0104166667
}
export const inchToPx = (inch = 0) => {
  return inch * 96
}
export const cmToInch = (cm = 0) => {
  return cm * 0.393701;
}

export const percentToPx = (percent = 0) => {
  const pptWidthInPx = pptWidth * 96; 
  return (percent / 100) * pptWidthInPx;
}

export const calc = (px = 0, type = 'w', percentage = 100) => {
  const inches = pxToInch(px)
  return type === 'h'
    ? (percentage / 100) * (pptHeight - inches)
    : (percentage / 100) * (pptWidth - inches)
}

export const findHeight = (w, h, width) => {
  const height = (width * h) / w
  return Math.round(height)
}
export const findWidth = (w, h, height) => {
  const width = (height * w) / h
  return Math.round(width)
}

export const addClientLogoInFooter = (slide) => {
  const logoDetails = JSON.parse(window.localStorage.getItem('pptLogoDetails'))
  const clientLogo = {
    path: logoDetails.logoImgBase64,
    x: pxToInch(300),
    y: calc(40, 'h'),
    w: pxToInch(logoDetails.logoW),
    h: pxToInch(logoDetails.logoH),
  }
  slide.addImage(clientLogo)
}

export const defaultPptxSettings = (pptx, props) => {
  pptx.author = 'MavenMagnet Insights Assistant'
  pptx.company = 'MavenMagnet'
  pptx.revision = '1'
  pptx.subject = 'Annual Report'
  pptx.title = props?.title || 'Title'
  pptx.subTitle = props?.subTitle || 'Sub Title'
  pptx.defineLayout({ name: 'Custom', width: pptWidth, height: pptHeight })
  pptx.layout = 'Custom'

  pptx.defineSlideMaster(getDefinedSlideMaster('FIRST_SLIDE'))
  pptx.defineSlideMaster(getDefinedSlideMaster('MASTER_SLIDE'))
  pptx.defineSlideMaster(getDefinedSlideMaster('RECOMMENDATION_SLIDE'))
  pptx.defineSlideMaster(getDefinedSlideMaster('CUSTOMTABLE_SLIDE'))
  pptx.defineSlideMaster(getDefinedSlideMaster('BREAKER_SLIDE'))
  pptx.defineSlideMaster(getDefinedSlideMaster('LAST_SLIDE'))

  return pptx
}

function stringToObject(str) {
  // Check if the string is empty
  if (!str.trim()) {
    return {} // Return an empty object if the string is empty
  }

  let obj = {}
  const colorArray = {
    rgb_186_55_42: 'ba372a',
    rgb_22_145_121: '169179',
    rgb_230_126_35: 'e67e23',
    rgb_149_165_166: '95a5a6',
    rgb_52_73_94: '34495e',
  }

  // Split the string by semicolon to get individual key-value pairs
  let pairs = (str.split(';') || [str]).map((pair) => pair.trim()).filter((pair) => pair)

  // Iterate over each pair and split by ':' to separate key and value
  pairs.forEach((pair) => {
    let [key, value] = pair.split(':').map((item) => item.trim())

    // Modify the key: remove dashes and capitalize the letter following the dash
    let formattedKey = key.replace(/-([a-z])/g, (match) => match[1].toUpperCase())

    // Store the modified key and its corresponding value in the object
    if (formattedKey === 'color') {
      const val = value
        .replaceAll(',', '_')
        .replaceAll('(', '_')
        .replaceAll(')', '')
        .replaceAll(';', '')
        .replaceAll('#', '')
        .replaceAll(' ', '')
        .replace('#', '')
        .replaceAll(';', '')
      obj[formattedKey] = value.indexOf('rgb') !== -1 ? colorArray[val] : val
    } else if (formattedKey === 'fontSize') {
      const fontSizeVal = Number(value.replace(/\D/g, ''))
      obj[formattedKey] = fontSizeVal < 14 ? fontSizeVal + 2 : fontSizeVal
    } else {
      obj[formattedKey] = value
    }
  })

  return obj
}

export const getDefinedSlideMaster = (slideTitle) => {
  if (slideTitle === 'FIRST_SLIDE') {
    return {
      title: 'FIRST_SLIDE',
      background: { color: 'FFFFFF' },
      objects: [
        {
          image: {
            path: getImageUrl('ppt', 'ppt-bg1', 'jpg'),
            x: 0,
            y: 0,
            w: pptWidth,
            h: pptHeight,
          },
        },
        {
          image: {
            path: logoMaven,
            x: pxToInch(71),
            y: pxToInch(122),
            w: pxToInch(477),
            h: pxToInch(70),
          },
        },
        {
          placeholder: {
            text: '(Title)',
            options: {
              name: 'title',
              type: 'body',
              x: pxToInch(71),
              y: pxToInch(365),
              w: pxToInch(935),
              h: pxToInch(60),
              color: '#ffffff',
              fontSize: 31,
            },
          },
        },
        {
          placeholder: {
            text: '(Sub Title)',
            options: {
              name: 'subTitle',
              type: 'body',
              x: pxToInch(71),
              y: pxToInch(470),
              w: pxToInch(935),
              h: pxToInch(60),
              color: '#ffffff',
              fontSize: 23,
            },
          },
        },
        {
          placeholder: {
            text: '(Date)',
            options: {
              name: 'date',
              type: 'body',
              x: pxToInch(71),
              y: pxToInch(520),
              w: pxToInch(935),
              h: pxToInch(60),
              color: '#ffffff',
              fontSize: 23,
            },
          },
        },
        // { placeholder: { image: '(Image)', options: { name: 'clientLogo', path: 'clientLogo', x: pxToInch(71), y: pxToInch(122), w: pxToInch(477.35), h: pxToInch(70.67) } } },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  } else if (slideTitle === 'MASTER_SLIDE') {
    return {
      title: 'MASTER_SLIDE',
      background: { color: 'FFFFFF' },
      objects: [
        // { placeholder: { text: '', options: { name: 'title', type: 'body', x: pxToInch(40), y: pxToInch(13), w:calc(50), h:pxToInch(60), color: '#363636', fontSize: 32 } } },
        // { placeholder: { text: '     ', options: { name: 'subTitle', type: 'body', x: pxToInch(5), y: pxToInch(70), color: '#363636', fontSize: 20 } } },
        {
          rect: {
            fill: { type: 'solid', color: '#262626' },
            w: '100%',
            h: pxToInch(53),
            x: 0,
            y: calc(53, 'h'),
          },
        },
        {
          rect: {
            fill: { type: 'solid', color: '#e88b33' },
            x: pxToInch(19),
            y: pxToInch(120),
            w: pxToInch(20),
            h: calc(120, 'h'),
          },
        },
        {
          image: {
            path: logoMaven,
            x: pxToInch(59),
            y: calc(40, 'h'),
            w: pxToInch(202),
            h: pxToInch(29),
          },
        },
        {
          text: {
            text: '©mavenmagnet',
            options: {
              x: 0,
              y: calc(25.5, 'h'),
              w: calc(60),
              color: '#e88b33',
              fontSize: 14,
              align: 'right',
            },
          },
        },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  } else if (slideTitle === 'RECOMMENDATION_SLIDE') {
    return {
      title: 'RECOMMENDATION_SLIDE',
      background: { color: 'FFFFFF' },
      margin: [1, 1, 1, 1],
      objects: [
        {
          placeholder: {
            text: '  ',
            options: {
              name: 'title',
              type: 'body',
              x: pxToInch(45),
              y: pxToInch(13),
              color: '#363636',
              fontSize: 32,
            },
          },
        },
        {
          placeholder: {
            text: '  ',
            options: {
              name: 'subTitle',
              type: 'body',
              x: pxToInch(45),
              y: pxToInch(70),
              w: calc(90),
              color: '#363636',
              fontSize: 20,
            },
          },
        },

        {
          rect: {
            fill: { type: 'solid', color: '#262626' },
            w: '100%',
            h: pxToInch(53),
            x: 0,
            y: calc(53, 'h'),
          },
        },
        // { rect: { fill: { type: 'solid', color: '#FFFFFF' }, x: pxToInch(60), y: pxToInch(120), w: calc(90), h: calc(200, 'h'), rectRadius: 2, line: { color: "#000000", width: 2, beginArrowType: "diamond", endArrowType: "oval" } } },
        {
          rect: {
            fill: { type: 'solid', color: '#e88b33' },
            x: pxToInch(19),
            y: pxToInch(120),
            w: pxToInch(20),
            h: calc(120, 'h'),
          },
        },
        {
          image: {
            path: logoMaven,
            x: pxToInch(59),
            y: calc(40, 'h'),
            w: pxToInch(202),
            h: pxToInch(29),
          },
        },
        {
          text: {
            text: '©mavenmagnet',
            options: {
              x: 0,
              y: calc(25.5, 'h'),
              w: calc(60),
              color: '#e88b33',
              fontSize: 14,
              align: 'right',
            },
          },
        },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  } else if (slideTitle === 'CUSTOMTABLE_SLIDE') {
    return {
      title: 'CUSTOMTABLE_SLIDE',
      background: { color: 'FFFFFF' },
      margin: [1, 1, 1, 1],
      objects: [
        {
          placeholder: {
            text: '  ',
            options: {
              name: 'title',
              type: 'body',
              x: pxToInch(45),
              y: pxToInch(13),
              color: '#363636',
              fontSize: 32,
            },
          },
        },
        // { placeholder: { text: '  ', options: { name: 'subTitle', type: 'body', x: pxToInch(45), y: pxToInch(70), w:calc(90), color: '#363636', fontSize: 20 } } },

        {
          rect: {
            fill: { type: 'solid', color: '#262626' },
            w: '100%',
            h: pxToInch(53),
            x: 0,
            y: calc(53, 'h'),
          },
        },
        // { rect: { fill: { type: 'solid', color: '#FFFFFF' }, x: pxToInch(60), y: pxToInch(120), w: calc(90), h: calc(200, 'h'), rectRadius: 2, line: { color: "#000000", width: 2, beginArrowType: "diamond", endArrowType: "oval" } } },
        {
          rect: {
            fill: { type: 'solid', color: '#e88b33' },
            x: pxToInch(19),
            y: pxToInch(120),
            w: pxToInch(20),
            h: calc(120, 'h'),
          },
        },
        {
          image: {
            path: logoMaven,
            x: pxToInch(59),
            y: calc(40, 'h'),
            w: pxToInch(202),
            h: pxToInch(29),
          },
        },
        {
          text: {
            text: '©mavenmagnet',
            options: {
              x: 0,
              y: calc(25.5, 'h'),
              w: calc(60),
              color: '#e88b33',
              fontSize: 14,
              align: 'right',
            },
          },
        },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  } else if (slideTitle === 'BREAKER_SLIDE') {
    return {
      title: 'BREAKER_SLIDE',
      background: { color: 'FFFFFF' },
      objects: [
        {
          placeholder: {
            text: '',
            options: {
              name: 'title',
              type: 'body',
              x: pxToInch(40),
              y: '40%',
              w: calc(80),
              h: pxToInch(100),
              color: '#363636',
              align: 'center',
              fontSize: 32,
              bold: false,
            },
          },
        },
        {
          rect: {
            fill: { type: 'solid', color: '#262626' },
            w: '100%',
            h: pxToInch(53),
            x: 0,
            y: calc(53, 'h'),
          },
        },
        {
          rect: {
            fill: { type: 'solid', color: '#e88b33' },
            x: pxToInch(19),
            y: pxToInch(120),
            w: pxToInch(20),
            h: calc(120, 'h'),
          },
        },
        {
          image: {
            path: logoMaven,
            x: pxToInch(59),
            y: calc(40, 'h'),
            w: pxToInch(202),
            h: pxToInch(29),
          },
        },
        {
          text: {
            text: '©mavenmagnet',
            options: {
              x: 0,
              y: calc(25.5, 'h'),
              w: calc(60),
              color: '#e88b33',
              fontSize: 14,
              align: 'right',
            },
          },
        },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  } else if (slideTitle === 'LAST_SLIDE') {
    return {
      title: 'LAST_SLIDE',
      background: { color: 'FFFFFF' },
      objects: [
        {
          image: {
            path: getImageUrl('ppt', 'ppt-bg2', 'jpg'),
            x: 0,
            y: 0,
            w: pptWidth,
            h: pptHeight,
          },
        },
        {
          rect: {
            fill: { type: 'solid', color: '#262626' },
            w: '100%',
            h: pxToInch(53),
            x: 0,
            y: calc(53, 'h'),
          },
        },
        {
          text: {
            text: 'insightsassistant@mavenmagnet.com ',
            options: { x: 0, y: '50%', w: '100%', color: '#333333', fontSize: 14, align: 'center' },
          },
        },
        {
          text: {
            text: '©mavenmagnet',
            options: {
              x: 0,
              y: calc(25, 'h'),
              w: '100%',
              color: '#e88b33',
              fontSize: 14,
              align: 'center',
            },
          },
        },
      ],
      slideNumber: {
        x: 0,
        y: calc(45, 'h'),
        w: calc(10),
        color: '#f1f1f1',
        fontSize: 14,
        align: 'right',
      },
    }
  }
}

const cleanNode = (node) => {
  // Remove all attributes from the current node
  if (node.attributes) {
    while (node.attributes.length > 0) {
      node.removeAttribute(node.attributes[0].name)
    }
  }

  // Recursively process child nodes
  const childNodes = Array.from(node.childNodes)
  childNodes.forEach((child) => {
    if (child.nodeType === Node.ELEMENT_NODE) {
      if (child.tagName.toLowerCase() === 'span') {
        // Replace <span> tag with its content (remove the span tag)
        const parent = child.parentNode
        while (child.firstChild) {
          parent.insertBefore(child.firstChild, child)
        }
        if (parent.hasChildNodes() || parent.hasChildNode()) {
          parent.removeChild(child)
        }
      } else {
        // Recursively clean other nodes
        cleanNode(child)
      }
    }
  })
}

export const convertHtmlToPptJson = async (id, props) => {

  // Set default values for props
  const bulletList = props?.bulletList ?? ['dot', '25CC', '25AA', 'dot', '25CC', '25AA']
  const componentType = props?.componentType ?? ''
  const downloadType = props?.downlaodType ?? ''
  const hasTable = props?.hasTable ?? false

  // Determine colspan based on component type
  let getColSpan =
    componentType === 'CustomTable'
      ? id?.querySelectorAll('td')?.length || 0
      : id?.querySelectorAll('tr')?.[0]?.querySelectorAll('td')?.length || 0

  id.innerHTML = id.innerHTML.replace(/\n/g, '')

  const result = await HTMLToJSON(id, false)
  const options = { fontSize: 14, color: '000000', lineSpacing: 22 } // lineSpacingMultiple: 0.0-9.99, paraSpaceAfter: 12,
  const resultArray = []

  // Utility to remove newlines and append a space
  const removeTagsFromStr = (str) => (String(str).replace(/\n/g, '') + ' ')

  // Process array data to return joined content
  const singleDataReturn = (data) => {
    return data
      .filter((item) => !(typeof item === 'string' && item.trim() === '\n')) // Filter out newline strings
      .map((item) => (typeof item === 'object' && item?.content ? item.content[0] : item)) // Extract content from objects
      .join('\n\n') // Join processed items
  }


  
const convertRteToPptObjects = (data, options, parentType = '') => {
    // PURLY FOR CUSTOMTABLE
    options['fontSize'] = 12 

    // Helper function to process content inside a TD/TH, handling nested lists (UL/OL)
    const processTableCellContent = (contentArray, currentListLevel = 0) => {
        let textSegments = []
        for (let i = 0; i < contentArray.length; i++) {
            const item = contentArray[i]

            if (item.type === 'P' && item.content?.length > 0) {
                 // Handle P tags (often containing plain text or verbatim)
                const text = removeTagsFromStr(item.content[0])
                if (text.trim().length > 0) {
                    textSegments.push({
                        text: text + ' ',
                        options: { color: options.color || '000000' }
                    })
                }
            } else if (['UL', 'OL'].includes(item.type) && item.content?.length > 0) {
                // Recursively handle nested UL/OL
                const listLevel = currentListLevel + 1
                for (let j = 0; j < item.content.length; j++) {
                    const listItem = item.content[j]
                    if (listItem.type === 'LI' && listItem.content) {
                        // The primary content of the LI is often an array containing text/P/nested UL/OL
                        const liContent = listItem.content
                        const liTextContent = liContent.filter(c => typeof c === 'string' || c.type === 'P')
                        const nestedListContent = liContent.filter(c => ['UL', 'OL'].includes(c.type))
                        
                        let liText = ''
                        if (liTextContent.length > 0) {
                            liText = singleDataReturn(liTextContent)
                        }

                        // Determine the bullet character and indentation
                        const bullet = bulletList[listLevel] === 'none' ? '  ' : '• '
                        const indent = '  '.repeat(listLevel - 1 > 0 ? listLevel - 1 : 0) // Visual indentation
                        const lineBreak = textSegments.length > 0 ? '\n' : ''

                        // Push the current LI text
                        textSegments.push({
                            text: lineBreak + indent + bullet + liText + ' ',
                            options: { color: options.color || '000000' }
                        })

                        // Process any nested UL/OL recursively within this LI
                        if (nestedListContent.length > 0) {
                            textSegments = textSegments.concat(processTableCellContent(nestedListContent, listLevel))
                        }
                    }
                }
            } else if (item.type === 'LI' && item.content) {
                 // Direct LI processing (for the original list items inside the TD content array)
                const liContent = item.content.filter(c => typeof c === 'string' || c.type === 'P' || ['UL', 'OL'].includes(c.type))
                const liTextContent = liContent.filter(c => typeof c === 'string' || c.type === 'P')
                const nestedListContent = liContent.filter(c => ['UL', 'OL'].includes(c.type))

                let liText = ''
                if (liTextContent.length > 0) {
                    liText = singleDataReturn(liTextContent)
                }

                // Initial list level bullet
                const bullet = bulletList[currentListLevel] === 'none' ? '  ' : '• '
                const indent = '  '.repeat(currentListLevel > 0 ? currentListLevel - 1 : 0)
                const lineBreak = textSegments.length > 0 ? '\n' : ''

                textSegments.push({
                    text: lineBreak + indent + bullet + liText + ' ',
                    options: { color: options.color || '000000' }
                })
                
                // Process any nested UL/OL recursively within this LI
                if (nestedListContent.length > 0) {
                     textSegments = textSegments.concat(processTableCellContent(nestedListContent, currentListLevel))
                }
            } else if (typeof item === 'string' && item.trim() !== '') {
                // Handle simple strings within the cell content array
                textSegments.push({
                    text: item + ' ',
                    options: { color: options.color || '000000' }
                })
            }
        }
        return textSegments
    }

    if (data?.type === 'LI' && data?.content?.length > 0) {
        // This is the original LI handling logic for standalone lists (not inside tables), which is currently not relevant for the provided TABLE data.
        // I'm keeping it concise as per the prompt's focus.
        
        for (let i = 0; i < data.content.length; i++) {
            let text = data.content[i]
            if (!data?.ListLevel) {
                data.ListLevel = 0
            }
            options['bold'] = false
            options['italic'] = false
            options['indentLevel'] = data.ListLevel
            if (componentType === 'recommendation') {
                options['indentLevel'] = data.ListLevel - 1
            }

            let bullet = { code: bulletList[data?.ListLevel] }
            if (bulletList[data?.ListLevel] === 'none') {
                options['bold'] = true
            }

            if (typeof data.content[i] === 'object' && ['UL', 'OL'].includes(data.content[i].type)) {
                const listLevel = data?.ListLevel + 1 || 0
                data.content[i]['ListLevel'] = listLevel
                const ulData = data.content[i].content
                    .filter((f) => f !== '\n')
                    .map((m) => {
                        return { ...m, ListLevel: listLevel }
                    })
                convertRteToPptObjects({ type: data.content[i].type, content: ulData }, options)
                continue
            } else if (
                typeof data.content[i] === 'object' &&
                ['TABLE', 'H4'].includes(data.content[i].type)
            ) {
                convertRteToPptObjects(data.content[i], options, data.type)
                continue
            }

            if (data.content[i] !== '\n' && typeof text !== 'object') {
                if (text.length > 0) {
                    resultArray.push([
                        {
                            type: data.type,
                            text: removeTagsFromStr(text),
                            options: { ...options, colspan: getColSpan, breakLine: false, bullet: bullet },
                        },
                    ])
                }
            }
        }

    } else if (
        ['TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TD', 'TH'].includes(data?.type) &&
        data?.content.length > 0
    ) {
        if (data.type === 'TR') {
            const trArray = []
            const trHeight = data?.attributes?.height || 0
            for (let t = 0; t < data.content.length; t++) {
                if (data.content[t] === '\n') {
                    continue
                } 

                const bg = parentType === 'THEAD' ? 'd3d3d3' : 'ffffff'
                let cellOptions = { ...options }
                cellOptions['bullet'] = false
                cellOptions['indentLevel'] = 0
                if (data.content[t]?.attributes) {
                    cellOptions = { ...cellOptions, ...data.content[t]?.attributes }
                }

                // *** REVISED LOGIC FOR TD/TH CONTENT HANDLING ***
                if (data.content[t]?.content) {
                    const content = data.content[t].content
                    
                    const textSegments = processTableCellContent(content, 0) // Start at list level 0

                    if (textSegments.length > 0) {
                        trArray.push({
                            trHeight: trHeight,
                            parentType: parentType,
                            type: data.type,
                            text: textSegments, // This will be the array of text objects
                            attributes: data.content[t]?.attributes || {},
                            options: {
                                ...cellOptions,
                                fill: { color: bg },
                                border: { pt: 0.5, color: '#d3d3d3' },
                            },
                        })
                    } else {
                        // Handle empty cell case
                         trArray.push({
                            trHeight: trHeight,
                            parentType: parentType,
                            type: data.type,
                            text: ' ', 
                            attributes: data.content[t]?.attributes || {},
                            options: {
                                ...cellOptions,
                                fill: { color: bg },
                                border: { pt: 0.5, color: '#d3d3d3' },
                            },
                        })
                    }

                } else {
                    // Default behavior for cells without complex content (shouldn't happen with the provided data)
                    trArray.push({
                        trHeight: trHeight,
                        parentType: parentType,
                        type: data.type,
                        text: ' ',
                        attributes: data.content[t]?.attributes || {},
                        options: { ...cellOptions, fill: { color: bg }, border: { pt: 0.5, color: '#d3d3d3' } },
                    })
                }
            }
            resultArray.push(trArray)
        } else {
            for (let i = 0; i < data.content.length; i++) {
                if (typeof data.content[i] === 'object') {
                    convertRteToPptObjects(data.content[i], options, data.type)
                }
            }
        }
    } else if (data?.content) {
        // General content block, handling P, STRONG, EM, etc.
        for (let i = 0; i < data.content.length; i++) {
            if (typeof data.content[i] === 'object') {
                if (['UL', 'OL'].includes(data.type)) {
                    data.ListLevel = 0
                }
                convertRteToPptObjects(data.content[i], options)
            } else if (typeof data.content[i] === 'string') {
                options['bold'] = data.type === 'STRONG'
                options['italic'] = data.type === 'EM'
                options['bullet'] = false
                options['breakLine'] = false
                if (data.content[i] === '\n') {
                    options.breakLine = true
                    options.fontSize = 2
                }
                if (data.type === 'P') {
                    options.breakLine = true
                }

                if (['UL', 'OL'].includes(data.type)) {
                    continue
                } else {
                    resultArray.push([
                        {
                            type: data.type,
                            text: removeTagsFromStr(data.content[i]) + ' ',
                            options: { ...options, colspan: getColSpan },
                        },
                    ])
                }
            }
        }
    }
  }

  const bulletCodes = {
    0: 'dot', // Top-level bullet
    1: '25CC', // Nested-level bullet
    2: '25AA', // Deeper nested bullet
  }

  // New function to convert the INPUT format to the OUTPUT format
  function convertToOutputFormatNew(input) {
    function processMultiText(
      contentArray,
      parentIndentLevel = 0,
      parentObject = {},
      parentStyles = {}
    ) {
      const finalArr = contentArray
        // .filter(f => (typeof f === 'string' || f?.type !== 'UL'))
        .filter((f) => typeof f === 'string' || !['UL', 'OL'].includes(f?.type))
        // .filter(f => (typeof f === 'string' || f?.type !== 'UL' || f?.type !== 'OL')) // throwing error
        .map((d, i) => {
          if (typeof d === 'string') {
            const styleObject = stringToObject(parentObject?.attributes?.style || '')
            let indenting = parentIndentLevel + 1
            let bullet = i === 0 ? true : false

            if (indenting === 0) bullet = false
            else if (bullet) bullet = { code: bulletList[indenting] }

            if (indenting === 1) indenting = 0
            else if (indenting === 2) indenting = 1
            else if (indenting === 3) indenting = 2
            else if (indenting === 4) indenting = 3

            return {
              type: d?.type || parentObject?.type,
              text: d,
              options: {
                ...options,
                // bulletIndent: i===0 ? indenting : false,
                // indentLevel: i===0 ? indenting+' pt' : 0,
                indentLevel: i === 0 ? indenting : 0,
                bullet: bullet,
                breakLine: false,
                // bulletType: styleObject?.listStyleType || defaultBulletTypeArray[indenting],
                fontSize: styleObject?.fontSize || parentStyles?.fontSize || 14,
                color: styleObject?.color || '000000',
                bold: styleObject?.fontWeight || parentObject?.type === 'STRONG' || false,
                underline: styleObject?.textDecoration === 'underline',
                italic: parentObject?.type === 'EM' || parentStyles?.italic,
                margin: 0.5,
              },
            }
          } else if (typeof d === 'object') {
            if (d?.content?.length > 0) {
              const parentStyle = parentStyles || {}
              const parentStyleObject = stringToObject(d?.attributes?.style || '')
              if (d.type === 'EM') {
                parentStyle['italic'] = true
              }
              if (parentStyleObject?.fontSize) {
                parentStyle['fontSize'] = parentStyleObject?.fontSize
              }

              const obj = processMultiText(d.content, parentIndentLevel, d, parentStyle)
              return obj
            }

            return {}
          }
        })
        .flat(1)

      const finalArray = []
      for (let i = 0; i < finalArr.length; i++) {
        const d = finalArr[i]
        if (d?.options) {
          if (i > 0 && d?.options?.indentLevel) delete d.options.indentLevel
          if (i > 0 && d?.options?.bullet) delete d.options.bullet

          d.options['breakLine'] = i === finalArr.length - 1
        }

        finalArray.push(d)
      }
      return finalArray
    }
    // Recursive helper function to handle nested lists
    function processItem(item, indentLevel, parentObject = {}) {
      let output = []

      // if (item.type === "UL") {
      if (['UL', 'OL'].includes(item.type)) {
        // For each UL, process its content
        item.content.forEach((subItem) => {
          if (subItem?.type === 'LI' && subItem?.content?.[0]) {
            const contentLen = subItem.content.length

            // Create the LI output with its options
            if (contentLen === 1 && subItem.content[0].type === 'HR') {
              const array = [
                {
                  type: 'HR',
                  text: '',
                  options: {},
                },
              ]
              output.push(array)
            } else if (contentLen === 1) {
              const array = processMultiText(subItem.content, indentLevel, subItem)
              const attr = stringToObject(subItem?.attributes?.style || '')

              // if(subItem?.type==='LI' && attr?.listStyleType === 'none' && subItem?.content?.length === 1 && subItem?.content?.[0]?.type === 'UL' ){
              if (
                subItem?.type === 'LI' &&
                attr?.listStyleType === 'none' &&
                subItem?.content?.length === 1 &&
                ['UL', 'OL'].includes(subItem?.content?.[0]?.type)
              ) {
                const array2 = processMultiText(
                  subItem.content[0].content,
                  indentLevel + 1,
                  subItem.content[0]
                )
                output.push(array2)
              } else {
                output.push(array)
              }
            } else if (
              contentLen >= 2 &&
              (subItem.content[1].type != 'UL' || subItem.content[1].type != 'OL')
            ) {
              const array = processMultiText(subItem.content, indentLevel, subItem)
              output.push(array)
            } else if (contentLen === 2 && ['UL', 'OL'].includes(subItem.content[1].type)) {
              const array = processMultiText([subItem.content[0]], indentLevel, subItem)
              output.push(array)
            }

            if (contentLen >= 2 && ['UL', 'OL'].includes(subItem.content[contentLen - 1]?.type)) {
              const array = processItem(
                subItem.content[contentLen - 1],
                indentLevel + 1,
                parentObject
              )
              output.push(array)
            }
          }
        })
      } else if (['P', 'H4', 'SPAN', 'STRONG', 'HR'].includes(item.type)) {
        const styleObject = stringToObject(item?.attributes?.style || '')
        if (item.type === 'HR') {
          const array = [
            {
              type: 'HR',
              text: '',
              options: {},
            },
          ]
          output.push(array)
        } else if (item?.content?.length > 0) {
          const array = processMultiText(item.content, -1, item)
          output.push(array)
        } else {
          console.log('ELSE >>>>> CODING IS PENDING', item)
          // const array = processMultiText(item.content, indentLevel, item)
          // output.push(array)
        }
      }

      return output
    }

    // Start processing the root input with an indentLevel of 0
    let output = []
    input.forEach((item, index) => {
      const i = processItem(item, 0, {})
      // output = output.concat(processItem(item, 0, parentObject = {}));
      if (index === input.length - 1) {
        output.push([...i])
      } else {
        output.push(i)
      }
    })

    return output
  }
  // const OUTPUT = convertToOutputFormatNew(INPUT);

  // Convert the INPUT to the OUTPUT format using the new function
  // let INPUT = (componentType === 'recommendation') ? result.content : result.content[0].content

  // const OUTPUT = convertToOutputFormatNew(INPUT()).flat(4).filter(obj => obj?.type)//.map(d => [d])//.slice(0, 3);

  const OUTPUT_FUNC = () => {
    if (hasTable) {
      const array = convertToOutputFormatNew(result.content)
        .flat(8)
        .filter((obj) => obj?.type)
      const checkTable = array.filter((obj) => ['TABLE', 'TR', 'TD'].includes(obj?.type))
      if (checkTable?.length > 0) {
        convertRteToPptObjects(result, options)
        return resultArray
      }
      return array
    } else if (componentType === 'recommendation' && downloadType === 'ppt') {
      const array = convertToOutputFormatNew(result.content)
        .flat(8)
        .filter((obj) => obj?.type)
      return array
    } else if (componentType === 'recommendation' && downloadType === 'doc') {
      const array = convertToOutputFormatNew(result.content)
        .flat(8)
        .filter((obj) => obj?.type)
      return array
    } else if (componentType === 'businessObjective') {
      const array = convertToOutputFormatNew(result.content[0].content)
        .flat(8)
        .filter((obj) => obj?.type) //.slice(0, 13)
      return array
    } else if (componentType === 'CustomTable') {
      convertRteToPptObjects(result, options)
      return resultArray
    }
    return []
  }

  const OUTPUT = OUTPUT_FUNC()

  let myPromise = new Promise(function (myResolve, myReject) {
    setTimeout(function () {
      myResolve(OUTPUT)
    }, 200)
  })

  return myPromise
}

// NOTE: ACCORDING TO CALIBRI FONT FAMILY
export const characterWidthsInInches = {
  10: {
    a: 0.0732, b: 0.0768, c: 0.0684, d: 0.0768, e: 0.0732, f: 0.0419, g: 0.0768,
    h: 0.0768, i: 0.0323, j: 0.0323, k: 0.0684, l: 0.0323, m: 0.1197, n: 0.0768,
    o: 0.0768, p: 0.0768, q: 0.0768, r: 0.0452, s: 0.0648, t: 0.0419, u: 0.0768,
    v: 0.0684, w: 0.1026, x: 0.0684, y: 0.0684, z: 0.0648,
    A: 0.0851, B: 0.0851, C: 0.0936, D: 0.0936, E: 0.0851, F: 0.0766, G: 0.0972,
    H: 0.0936, I: 0.0378, J: 0.0648, K: 0.0851, L: 0.0732, M: 0.1107, N: 0.0936,
    O: 0.1020, P: 0.0851, Q: 0.1020, R: 0.0890, S: 0.0851, T: 0.0766, U: 0.0936,
    V: 0.0851, W: 0.1278, X: 0.0851, Y: 0.0851, Z: 0.0851,
    '0': 0.1020, '1': 0.0936, '2': 0.1020, '3': 0.1020, '4': 0.1020,
    '5': 0.1020, '6': 0.1020, '7': 0.1020, '8': 0.1020, '9': 0.1020,
    ' ': 0.0306
  },
  11: {
    a: 0.0805, b: 0.0845, c: 0.0753, d: 0.0845, e: 0.0805, f: 0.0468, g: 0.0845,
    h: 0.0845, i: 0.0355, j: 0.0355, k: 0.0753, l: 0.0355, m: 0.1317, n: 0.0845,
    o: 0.0845, p: 0.0845, q: 0.0845, r: 0.0498, s: 0.0708, t: 0.0468, u: 0.0845,
    v: 0.0753, w: 0.1129, x: 0.0753, y: 0.0753, z: 0.0708,
    A: 0.0937, B: 0.0937, C: 0.1029, D: 0.1029, E: 0.0937, F: 0.0844, G: 0.1072,
    H: 0.1029, I: 0.0414, J: 0.0708, K: 0.0937, L: 0.0805, M: 0.1214, N: 0.1029,
    O: 0.1122, P: 0.0937, Q: 0.1122, R: 0.0979, S: 0.0937, T: 0.0844, U: 0.1029,
    V: 0.0937, W: 0.1406, X: 0.0937, Y: 0.0937, Z: 0.0937,
    '0': 0.1122, '1': 0.1029, '2': 0.1122, '3': 0.1122, '4': 0.1122,
    '5': 0.1122, '6': 0.1122, '7': 0.1122, '8': 0.1122, '9': 0.1122,
    ' ': 0.0336
  },
  12: {
    a: 0.0878, b: 0.0922, c: 0.0821, d: 0.0922, e: 0.0878, f: 0.0516, g: 0.0922,
    h: 0.0922, i: 0.0387, j: 0.0387, k: 0.0821, l: 0.0387, m: 0.1438, n: 0.0922,
    o: 0.0922, p: 0.0922, q: 0.0922, r: 0.0545, s: 0.0768, t: 0.0516, u: 0.0922,
    v: 0.0821, w: 0.1232, x: 0.0821, y: 0.0821, z: 0.0768,
    A: 0.1022, B: 0.1022, C: 0.1122, D: 0.1122, E: 0.1022, F: 0.0923, G: 0.1172,
    H: 0.1122, I: 0.0451, J: 0.0768, K: 0.1022, L: 0.0878, M: 0.1321, N: 0.1122,
    O: 0.1224, P: 0.1022, Q: 0.1224, R: 0.1069, S: 0.1022, T: 0.0923, U: 0.1122,
    V: 0.1022, W: 0.1533, X: 0.1022, Y: 0.1022, Z: 0.1022,
    '0': 0.1224, '1': 0.1122, '2': 0.1224, '3': 0.1224, '4': 0.1224,
    '5': 0.1224, '6': 0.1224, '7': 0.1224, '8': 0.1224, '9': 0.1224,
    ' ': 0.0367
  },
  13: {
    a: 0.0951, b: 0.0999, c: 0.0889, d: 0.0999, e: 0.0951, f: 0.0565, g: 0.0999,
    h: 0.0999, i: 0.0419, j: 0.0419, k: 0.0889, l: 0.0419, m: 0.1559, n: 0.0999,
    o: 0.0999, p: 0.0999, q: 0.0999, r: 0.0592, s: 0.0828, t: 0.0565, u: 0.0999,
    v: 0.0889, w: 0.1335, x: 0.0889, y: 0.0889, z: 0.0828,
    A: 0.1108, B: 0.1108, C: 0.1215, D: 0.1215, E: 0.1108, F: 0.1001, G: 0.1273,
    H: 0.1215, I: 0.0487, J: 0.0828, K: 0.1108, L: 0.0951, M: 0.1428, N: 0.1215,
    O: 0.1326, P: 0.1108, Q: 0.1326, R: 0.1159, S: 0.1108, T: 0.1001, U: 0.1215,
    V: 0.1108, W: 0.1659, X: 0.1108, Y: 0.1108, Z: 0.1108,
    '0': 0.1326, '1': 0.1215, '2': 0.1326, '3': 0.1326, '4': 0.1326,
    '5': 0.1326, '6': 0.1326, '7': 0.1326, '8': 0.1326, '9': 0.1326,
    ' ': 0.0398
  },
  14: {
    a: 0.1024, b: 0.1076, c: 0.0957, d: 0.1076, e: 0.1024, f: 0.0613, g: 0.1076,
    h: 0.1076, i: 0.0451, j: 0.0451, k: 0.0957, l: 0.0451, m: 0.1679, n: 0.1076,
    o: 0.1076, p: 0.1076, q: 0.1076, r: 0.0638, s: 0.0889, t: 0.0613, u: 0.1076,
    v: 0.0957, w: 0.1439, x: 0.0957, y: 0.0957, z: 0.0889,
    A: 0.1193, B: 0.1193, C: 0.1308, D: 0.1308, E: 0.1193, F: 0.1079, G: 0.1375,
    H: 0.1308, I: 0.0521, J: 0.0889, K: 0.1193, L: 0.1024, M: 0.1535, N: 0.1308,
    O: 0.1427, P: 0.1193, Q: 0.1427, R: 0.1248, S: 0.1193, T: 0.1079, U: 0.1308,
    V: 0.1193, W: 0.1785, X: 0.1193, Y: 0.1193, Z: 0.1193,
    '0': 0.1427, '1': 0.1308, '2': 0.1427, '3': 0.1427, '4': 0.1427,
    '5': 0.1427, '6': 0.1427, '7': 0.1427, '8': 0.1427, '9': 0.1427,
    ' ': 0.0428
  },
  15: {
    a: 0.1097, b: 0.1152, c: 0.1025, d: 0.1152, e: 0.1097, f: 0.0661, g: 0.1152,
    h: 0.1152, i: 0.0483, j: 0.0483, k: 0.1025, l: 0.0483, m: 0.1799, n: 0.1152,
    o: 0.1152, p: 0.1152, q: 0.1152, r: 0.0684, s: 0.0950, t: 0.0661, u: 0.1152,
    v: 0.1025, w: 0.1542, x: 0.1025, y: 0.1025, z: 0.0950,
    A: 0.1278, B: 0.1278, C: 0.1401, D: 0.1401, E: 0.1278, F: 0.1156, G: 0.1477,
    H: 0.1401, I: 0.0549, J: 0.0950, K: 0.1278, L: 0.1097, M: 0.1642, N: 0.1401,
    O: 0.1529, P: 0.1278, Q: 0.1529, R: 0.1338, S: 0.1278, T: 0.1156, U: 0.1401,
    V: 0.1278, W: 0.1911, X: 0.1278, Y: 0.1278, Z: 0.1278,
    '0': 0.1529, '1': 0.1401, '2': 0.1529, '3': 0.1529, '4': 0.1529,
    '5': 0.1529, '6': 0.1529, '7': 0.1529, '8': 0.1529, '9': 0.1529,
    ' ': 0.0459
  },
  16: {
    a: 0.1171, b: 0.1229, c: 0.1093, d: 0.1229, e: 0.1171, f: 0.0710, g: 0.1229,
    h: 0.1229, i: 0.0515, j: 0.0515, k: 0.1093, l: 0.0515, m: 0.1920, n: 0.1229,
    o: 0.1229, p: 0.1229, q: 0.1229, r: 0.0730, s: 0.1010, t: 0.0710, u: 0.1229,
    v: 0.1093, w: 0.1645, x: 0.1093, y: 0.1093, z: 0.1010,
    A: 0.1362, B: 0.1362, C: 0.1494, D: 0.1494, E: 0.1362, F: 0.1234, G: 0.1579,
    H: 0.1494, I: 0.0580, J: 0.1010, K: 0.1362, L: 0.1171, M: 0.1748, N: 0.1494,
    O: 0.1632, P: 0.1362, Q: 0.1632, R: 0.1427, S: 0.1362, T: 0.1234, U: 0.1494,
    V: 0.1362, W: 0.2037, X: 0.1362, Y: 0.1362, Z: 0.1362,
    '0': 0.1632, '1': 0.1494, '2': 0.1632, '3': 0.1632, '4': 0.1632,
    '5': 0.1632, '6': 0.1632, '7': 0.1632, '8': 0.1632, '9': 0.1632,
    ' ': 0.0489
  }
};


// Estimate text width dynamically
export function estimateTextWidth(text = '', fontSize = 11) {
  return [...text].map(l => characterWidthsInInches[fontSize][l]).reduce((accumulator, current) => accumulator + current, 0);
}

// Estimate text height dynamically
export function estimateTextHeight(text = '', width, fontSize = 11, lineSpacingPt = 13) {
  if (!text) return { height: 0.22, lines: 1 };

  const fontMap = characterWidthsInInches[fontSize];
  if (!fontMap) throw new Error(`Font size ${fontSize} not supported`);

  const lineHeightInches = lineSpacingPt / 72;
  // reduce slightly for wrap safety
  const safeWidth = width - 0.1; 

  const words = text.split(/\s+/);
  let lines = 1;
  let currentLineWidth = 0;

  for (let word of words) {
    // keeps dashes as tokens
    const subwords = word.split(/(?<=-)|(?=-)/g); 

    for (let sub of subwords) {
      const wordWidth = [...sub].reduce((sum, char) => {
        const normalized = char.toLowerCase();
        return sum + (fontMap[char] || fontMap[normalized] || 0.06);
      }, 0);

      const spaceWidth = fontMap[' '] || 0.03;
      if (currentLineWidth + wordWidth + (currentLineWidth > 0 ? spaceWidth : 0) > safeWidth) {
        lines++;
        currentLineWidth = wordWidth;
      } else {
        currentLineWidth += wordWidth + spaceWidth;
      }
    }
  }

  const totalHeight = Math.max(lineHeightInches * lines, 0.22);
  return { height: totalHeight, lines };
}


export function breakLongWords(text, limit = 25) {
  return text.replace(new RegExp(`(\\S{${limit}})(?=\\S)`, 'g'), '$1\u200B');
}

export function getSentimentColor(data , box = false) {
  const negative = data.find(d => d.ImageryIndexSentiment === 'Negative');
  const positive = data.find(d => d.ImageryIndexSentiment === 'Positive');
  if (positive && !negative) return '28A745';
  if (negative && !positive) return 'DC3545';
  return box ? 'FFFFFF' : '';
}

// Create a Legends Based On Types
export const dynamicLegends = (type) => {
  const legendsObj = {
    'Drivers': [
      { text: "Positive", options: { color: "00B050" } },
      { text: "Neutral", options: { color: "F5BD4F" } },
      { text: "Mixed", options: { color: "A6A6A6", spacing: 0.65 } },
      { text: "Negative", options: { color: "FF0000" } },
    ],
    'CompetitiveLandscape': [
      { text: "Standout Insight", options: { color: "7C868F", shape: 'circle', radius: 5, width : 1.5 , spacing : 1.3} },
      { text: "Positive", options: { color: "00B050" } },
      { text: "Neutral", options: { color: "F5BD4F" } },
      { text: "Mixed", options: { color: "A6A6A6", spacing: 0.65 } },
      { text: "Negative", options: { color: "FF0000" } },
    ],
    'CompetitiveLandscapeBrandImagery': [
      { text: "Standout Insight", options: { color: "7C868F", shape: 'circle', radius: 5, width: 1.5, spacing: 1.3 } },
      { text: "Driver Level", options: { color: "FFFF00", shape: 'driver', spacing: 1 } },
      { text: "Attribute/SubAttribute Level", options: { color: "99ABCC", shape: 'attribute', spacing: 2.1, width: 2.1, } },
      { text: "Outperform", options: { color: "00B050", spacing: 1.1 } },
      { text: "Underperform", options: { color: "FF0000", spacing: 1.1 } },
    ]
  }

  return legendsObj[type];
}

export const rect = { x: 0.57, y: 1.15, w: 12.47, h: 5.43 }

export const generateLegend = (pptx, slide, type, data) => {
  let legends = dynamicLegends(type)
  if(type === ''){
    legends = Object.keys(data).map(d => ({text: d, options: { color: data[d], shape: 'attribute', spacing: estimateTextWidth(d, 11) + 0.25, width: estimateTextWidth(d, 11) + 0.25, } }))
  }
  if (legends?.length > 0) {
    const legendY = 6.65;
    let slideStartX = -0.6;
    legends.forEach((legend) => {
      slideStartX += legend?.options?.spacing || 0.75;
    })

    let legendX = rect.w - slideStartX;
    const legendBoxSize = 0.1;

    legends.forEach((legend) => {
      slide.addShape(pptx.ShapeType.roundRect, {
        x: legendX, y: legendY + 0.12,
        w: legendBoxSize, h: legendBoxSize,
        fill: { color: legend.options.color || '999999' },
        roundRadius: legend.options.radius || 1
      });

      slide.addText(legend.text, {
        x: legendX + 0.05,
        y: legendY,
        w: legend?.options?.width || 1.2,
        h: 0.3,
        fontSize: 11,
        color: '4D4D4D',
        align: 'left',
      });

      legendX += legend.options.spacing || 0.75;
    });
  }
}

export const heading1_text = (txt) => {
  return txt.toUpperCase()
}
export const heading1_css = (txt) => {
  let dynamicFontSize = 0
  if (txt.length < 50) {
    dynamicFontSize = 32
  } else if (txt.length < 60) {
    dynamicFontSize = 28
  } else if (txt.length < 70) {
    dynamicFontSize = 24
  }
  return {
    type: 'body',
    valign: 'top',
    x: pxToInch(40),
    y: pxToInch(13),
    w: calc(50),
    h: pxToInch(60),
    color: '#363636',
    fontSize: dynamicFontSize,
  }
}


export const heading2_text = (txt) => {
  return txt.toUpperCase()
}
export const heading2_css = (txt) => {
  const dynamicFontSize = 24

  return {
    type: 'body',
    valign: 'top',
    x: pxToInch(40),
    y: pxToInch(70),
    w: calc(50),
    h: pxToInch(30),
    color: '#363636',
    fontSize: dynamicFontSize,
  }
}

export const subTitleObject = {
  valign: 'top',
  type: 'body',
  x: pxToInch(40),
  y: pxToInch(70),
  w: calc(50),
  h: calc(200, 'h'),
  color: '#363636',
  fontSize: 20,
}

export const subSubTitleObject = {
  valign: 'top',
  type: 'body',
  x: pxToInch(40),
  y: pxToInch(70),
  w: calc(50),
  h: calc(200, 'h'),
  color: '#363636',
  fontSize: 15,
}


const dynamicSplitData_getDynamicKeys = (data) => {
    if (!data || data.length === 0) {
        return { columnKeys: [], htmlKeys: [] };
    }
    
    const columnKeys = Object.keys(data[0]).filter(key => 
        key.startsWith('column') && 
        !key.endsWith('_value') && 
        !key.endsWith('_type')
    );
    const htmlKeys = ['topic', ...columnKeys];

    return { columnKeys, htmlKeys };
}

const dynamicSplitData_isNumberColumn = (item, colKey) => item[`${colKey}_type`] === 'number';

const dynamicSplitData_stripHtml = (html) => html.replace(/<[^>]*>?/gm, '').trim();

const dynamicSplitData_splitRawValue = (originalValue, htmlParts) => {
    if (typeof originalValue !== 'string') return new Array(htmlParts.length).fill('');
    
    let parts = [];
    let remainingValue = originalValue;

    for (let i = 0; i < htmlParts.length; i++) {
        const partHtml = htmlParts[i];
        const partPlainText = dynamicSplitData_stripHtml(partHtml).trim();
        
        if (i < htmlParts.length - 1) {
            // For all parts except the last one, find the plain text chunk in the remaining value.
            const index = remainingValue.indexOf(partPlainText);
            
            if (index !== -1) {
                const partLength = index + partPlainText.length;
                parts.push(remainingValue.substring(0, partLength).trim());
                remainingValue = remainingValue.substring(partLength).trimStart();
            } else {
                // Fallback: If we can't find it, assume the rest is in the current part.
                parts.push(remainingValue);
                remainingValue = "";
                break;
            }
        } else {
            // The last part takes all remaining value
            parts.push(remainingValue);
        }
    }
    
    // Ensure we return the correct number of parts, even if the split logic failed for some
    while (parts.length < htmlParts.length) {
        parts.push('');
    }
    
    return parts;
}

export const dynamicSplitData = (data) => {
  const result = [];
    const hrTag = "<hr>";
    const { columnKeys, htmlKeys } = dynamicSplitData_getDynamicKeys(data);

    for (const item of data) {
        const splitColumns = new Map(); // Stores { colKey: [part1, part2, ...], ... }
        let maxSplits = 1;

        // --- Step 1: Identify all splits and determine the maximum number of new rows ---
        for (const colKey of htmlKeys) {
            const htmlContent = item[colKey] || '';
            if (htmlContent.includes(hrTag)) {
                const htmlParts = htmlContent.split(hrTag);
                const valueKey = `${colKey}_value`;
                
                // Get the split parts for both HTML and the corresponding raw value
                const valueParts = columnKeys.includes(colKey) 
                    ? dynamicSplitData_splitRawValue(item[valueKey], htmlParts) 
                    : new Array(htmlParts.length).fill(''); // Only split if it's a 'column' field

                splitColumns.set(colKey, { 
                    html: htmlParts, 
                    value: valueParts 
                });
                
                maxSplits = Math.max(maxSplits, htmlParts.length);
            }
        }

        // --- Step 2: Handle non-split rows and proceed to unroll split rows ---
        if (maxSplits === 1) {
            result.push(item);
            continue;
        }

        // --- Step 3: Unroll (flatten) the split columns into new rows ---
        for (let i = 0; i < maxSplits; i++) {
            const newRow = { ...item }; // Start with a copy of the original row

            // Apply the general clearing logic for all subsequent parts (i > 0)
            if (i > 0) {
                for (const key of Object.keys(newRow)) {
                    // Clear all standard HTML columns ('topic', 'columnN')
                    if (htmlKeys.includes(key)) {
                        newRow[key] = "";
                    }
                    
                    // Clear the _value fields, unless it's a number column
                    if (key.endsWith('_value')) {
                        const originalKey = key.replace('_value', '');
                        if (columnKeys.includes(originalKey) && dynamicSplitData_isNumberColumn(item, originalKey)) {
                            newRow[key] = item[key]; // Retain number
                        } else {
                            newRow[key] = ""; // Clear string/other values
                        }
                    }
                    
                    // Clear the _type fields for all columns
                    if (key.endsWith('_type')) {
                        newRow[key] = "";
                    }
                }
            }
            
            // Overwrite the content for columns that were split
            for (const [colKey, parts] of splitColumns.entries()) {
                const isColumnKey = columnKeys.includes(colKey);
                
                // Determine if this column's content should be repeated or advanced
                let partIndex;
                if (parts.html.length === maxSplits) {
                    // If this column has the max splits, use its current part
                    partIndex = i;
                } else if (i < parts.html.length) {
                    // If this column has fewer splits, advance until its parts run out
                    partIndex = i;
                } else {
                    // If all this column's parts have been used, repeat the last part or clear it (we'll clear it here for safety, though repeating the last item is often desired)
                    // partIndex = parts.html.length - 1; // Repeat the last part
                }
                
                // Set the HTML content
                newRow[colKey] = parts.html[partIndex] || ""; 
                
                // Set the raw value content
                if (isColumnKey) {
                    const valueKey = `${colKey}_value`;
                    const typeKey = `${colKey}_type`;

                    // Set the split value part
                    newRow[valueKey] = parts.value[partIndex] || "";
                    
                    // For subsequent rows (i > 0), the type is cleared unless it's the first split
                    if (i > 0) {
                        newRow[typeKey] = "";
                    }
                }
            }

            result.push(newRow);
        }
    }

    return result;
}
